import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/workspace/layouts/default.vue").then(m => m.default || m))
}